// Selectors over the sale draft. Kept here so the SaleView stays focused on UI.

import { useMemo } from "react";
import { useSaleDraft } from "./draft-store";

// Returns a map of productId -> { linesCount, totalCents } for the items in the
// current draft. Used by the product grid to show "1 unidad" / "2 unidades" badges.
export function useSaleDraftItemsByCategory() {
  const items = useSaleDraft((s) => s.items);
  return useMemo(() => {
    const map = new Map<number, { linesCount: number; totalCents: number }>();
    for (const it of items) {
      const entry = map.get(it.productId) ?? { linesCount: 0, totalCents: 0 };
      entry.linesCount += it.qty;
      entry.totalCents += it.qty * (it.unitPriceCents - it.lineDiscountCents);
      map.set(it.productId, entry);
    }
    return Array.from(map.entries()).map(([productId, v]) => ({ productId, ...v }));
  }, [items]);
}
